export function AddAPhoto({ className }: { className?: string }) {
  return (
    <svg
      data-testid="add-a-photo-icon"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.3333 4.66683H12.2199L10.9999 3.3335H6.99992V4.66683H10.4133L11.6333 6.00016H14.3333V14.0002H3.66658V8.00016H2.33325V14.0002C2.33325 14.7335 2.93325 15.3335 3.66658 15.3335H14.3333C15.0666 15.3335 15.6666 14.7335 15.6666 14.0002V6.00016C15.6666 5.26683 15.0666 4.66683 14.3333 4.66683ZM5.66658 10.0002C5.66658 11.8402 7.15992 13.3335 8.99992 13.3335C10.8399 13.3335 12.3333 11.8402 12.3333 10.0002C12.3333 8.16016 10.8399 6.66683 8.99992 6.66683C7.15992 6.66683 5.66658 8.16016 5.66658 10.0002ZM8.99992 8.00016C10.0999 8.00016 10.9999 8.90016 10.9999 10.0002C10.9999 11.1002 10.0999 12.0002 8.99992 12.0002C7.89992 12.0002 6.99992 11.1002 6.99992 10.0002C6.99992 8.90016 7.89992 8.00016 8.99992 8.00016ZM3.66658 4.66683H5.66658V3.3335H3.66658V1.3335H2.33325V3.3335H0.333252V4.66683H2.33325V6.66683H3.66658V4.66683Z"
        fill="#2E2E2F"
      />
    </svg>
  )
}
